import moment from "moment";

type DateFormatVariant =
  | "DD/MM/YYYY"
  | "DD/MM/YYYY hh:mm:ss A"
  | "DD/MM/YY HH:mm:ss"
  | "DD/MM/YY HH:mm:ss"
  | "DD MMM YYYY"
  | "DD MMM YYYY, hh:mm A"
  | "YYYY-MM-DD HH:mm:ss"
  | "custom";

export const formatDateTime = (
  dateTime: string = "",
  variant: DateFormatVariant | string = "DD/MM/YYYY",
  customFormat?: string
): string | null => {
  if (!dateTime) return null;

  const parsed = moment(dateTime);
  if (!parsed.isValid()) return null;

  let formatString: string;

  switch (variant) {
    case "DD/MM/YYYY":
      formatString = "DD/MM/YYYY";
      break;

    case "DD/MM/YYYY hh:mm:ss A":
      formatString = "DD/MM/YYYY hh:mm:ss A";
      break;

    case "DD/MM/YY HH:mm:ss":
      formatString = "DD/MM/YY HH:mm:ss";
      break;

    case "DD MMM YYYY":
      formatString = "DD MMM YYYY";
      break;

    case "DD MMM YYYY, hh:mm A":
      formatString = "DD MMM YYYY, hh:mm A";
      break;

    case "YYYY-MM-DD HH:mm:ss":
      formatString = "YYYY-MM-DD HH:mm:ss";
      break;

    case "custom":
      formatString = customFormat || "DD/MM/YYYY";
      break;

    default:
      formatString = "DD/MM/YYYY";
  }

  return parsed.local().format(formatString);
};
